import React, { useCallback, useEffect, useMemo, useState }  from 'react';
import Button from 'react-bootstrap/Button';
import UserTable from './UserTable';
import styled from 'styled-components';
import Pagination from './Pagination';
import SelectLimit from './SelectLimit';
import { UserTableProps } from '../../types/global';
import { User } from '../../types/global';
import AddUserModal from '../modals/AddUserModal';
import DeleteModal from '../modals/DeleteModal';

const UserTableContainer = styled.div`
    width: 95vw;
    overflow: overlay;
    position: absolute;
    top: 10em;
    height: 70%;
    @media (max-height: 390px) {
        height: 9em;
    }
`
const UserButtonContainer = styled.div`
    position: absolute;
    top: 6em;
    right: 3%;
`

const TableComponent : React.FC<UserTableProps> = (props) => {

    const [currentPage, setCurrentPage] = useState(1);
    const [pageLimit, setPageLimit] = useState(5);
    const [pageNo, setPageNo] = useState(1);
    // const [users, setUsers] = useState<User[]>([]);
    const [currUsers, setCurrUsers] = useState<User[]>([]);

    const [showModal, setShowModal] = useState(false);
    const [userToEdit, setUserToEdit] = useState<User>();

    const getUsers = useCallback((page: number, limit: number) => {
        let array = [];
        for (let i= (page - 1) * limit; i<(page * limit) && props.users[i]; i++) {
            array.push(props.users[i])
        }
        return array;
    }, [props.users]);
    
    const getUsersLength = useMemo(() => {
        return props.users.length;
    }, []);
    
    let totalPageNumber = Math.ceil(getUsersLength / pageLimit);
    
    const onHandlePageChange = useCallback((value: any) => {
        if(value === "&laquo;" || value === "... ") {
            setCurrentPage(1);
        } else if (value === "&lsaquo;") {
            if (currentPage !== 1) {
                setCurrentPage(currentPage - 1);
            }
        } else if (value === "&rsaquo;") {
            if (currentPage !== totalPageNumber) {
                setCurrentPage(currentPage + 1);
            }
        } else if (value === "&raquo;" || value === " ...") {
            setCurrentPage(totalPageNumber);
        } else {
            setCurrentPage(value)
        }
    }, [currentPage, totalPageNumber]);
    
    useEffect(() => {
        if (currentPage <= totalPageNumber) {
            setPageNo(currentPage)
        } else {
            setCurrentPage(totalPageNumber)
            setPageNo(currentPage)
        }
    }, [currentPage, totalPageNumber])

    const handleUserAdded = useCallback((user: User) => {
        if (props.onUserAdded) {
            props.onUserAdded(user);
        }
    }, [props.onUserAdded]);

    const updateUserHandler = useCallback(async (id: string, user: User) => {
        setUserToEdit(user);
        setShowModal(true);
    }, []);

    return(
        <>
            <UserButtonContainer>
                <Button variant="outline-primary" onClick={() => setShowModal(true)}>Ajouter une ligne</Button>
            </UserButtonContainer>
            <UserTableContainer>
                <UserTable users={getUsers(currentPage, pageLimit)} deleteUserHandler={props?.deleteUserHandler} updateUserHandler={updateUserHandler} />
                <div className='pagination-container'>
                    <SelectLimit onLimitChange={setPageLimit} />
                    <Pagination totalPageNumber={totalPageNumber} pageNumber={currentPage} pageLimit={pageLimit} siblings={1} onPageChange={onHandlePageChange} />
                </div>
            </UserTableContainer>
            <AddUserModal setUsersObject={props?.setUsersObject} setUserToEdit={setUserToEdit} showModal={props?.isShowUpdateModal || showModal} setShowModal={setShowModal} onUserAdded={handleUserAdded} userToEdit={userToEdit} />
            <DeleteModal showModal={props?.showDeleteModal} setShowDeleteModal={props.setShowDeleteModal} confirmDeleteHandler={props.confirmDeleteHandler} />
        </>
    )
}

export default TableComponent;